// js
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// css
import '../../styles/components/common/RadioButton.scss';


function RadioButton({ checked }) {
  const classNames = classnames({
    'radio-button': true,
    'radio-button-checked': checked
  });

  return (
    <span className={classNames}>
      <span className='radio-button__dot' />
    </span>
  );
}

RadioButton.propTypes = {
  checked: PropTypes.bool
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/common/RadioButton.js